/* OVÉE DESIGN SYSTEM — sitewide motion (Oct 2026). Vanilla JS, loaded on every template.
   One reveal engine for the whole store (the homepage uses it too):
     - section headlines (H2) rise out of a mask, word by word, once
     - images tagged data-oh-media settle into their frames, once
     - anything tagged data-oh-reveal fades up, once
   Progressive: without JS, or with prefers-reduced-motion, everything renders in its
   final state. Nothing above the fold is ever hidden waiting for a reveal, and the buy
   box, cart, drawers, filters and forms are never touched. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;

  /* Where auto-tagging must never reach */
  var SKIP = '.product__info-container, .product__info-wrapper, .cart, cart-drawer, .drawer, ' +
    '.facets, .predictive-search, .customer, .jdgm-widget, header, footer, .header, .footer, ' +
    '.announcement-bar, .oh-hero, [data-no-motion]';

  function splitWords(el) {
    if (el.getAttribute('data-oh-split')) return;
    var text = el.textContent.replace(/\s+/g, ' ').trim();
    if (!text) return;
    el.setAttribute('aria-label', text);
    el.setAttribute('data-oh-split', '1');
    el.textContent = '';
    text.split(' ').forEach(function (word, i) {
      var w = document.createElement('span');
      w.className = 'oh-w';
      w.setAttribute('aria-hidden', 'true');
      var inner = document.createElement('span');
      inner.className = 'oh-w__i';
      inner.style.setProperty('--oh-i', i);
      inner.textContent = word;
      w.appendChild(inner);
      el.appendChild(w);
      el.appendChild(document.createTextNode(' '));
    });
  }

  /* Tag content headlines and a short list of image frames on non-homepage templates */
  function autoTag() {
    document.querySelectorAll('main h2').forEach(function (h) {
      if (h.hasAttribute('data-oh-words') || h.closest(SKIP)) return;
      var len = h.textContent.trim().length;
      if (len < 3 || len > 100) return;
      /* Only plain-text headlines: splitting would drop inline links, <br>, <em> */
      for (var i = 0; i < h.childNodes.length; i++) {
        if (h.childNodes[i].nodeType !== 3) return;
      }
      h.setAttribute('data-oh-words', '');
    });

    document.querySelectorAll('main .image-with-text__media').forEach(function (m) {
      if (!m.closest(SKIP)) m.setAttribute('data-oh-media', '');
    });
  }

  function initReveals() {
    autoTag();
    var targets = document.querySelectorAll('[data-oh-words], [data-oh-media], [data-oh-reveal], .oh-night');
    if (!targets.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    document.querySelectorAll('[data-oh-words]').forEach(splitWords);
    document.querySelectorAll('.oh-stars span').forEach(function (s, i) { s.style.setProperty('--oh-i', i); });

    /* Already on screen at load: mark in BEFORE the motion class turns the hidden states on */
    var vh = window.innerHeight;
    targets.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) el.classList.add('is-in');
    });

    root.classList.add('oh-motion');

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });

    targets.forEach(function (el) {
      if (!el.classList.contains('is-in')) io.observe(el);
    });
  }

  function boot() { initReveals(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme editor: re-run for sections added or reloaded in the editor */
  document.addEventListener('shopify:section:load', function () { initReveals(); });
})();
